const constants = require('./constants');

// List of the env variables you want to use on the client. Careful on what you put here!
const publicEnv = [
  'API_BASE',
  'APP_BASE',
  'DRYNOTES_ENV',
  'DRYNOTES_HOST',
  'DRYNOTES_HOST_NAME',
  'DRYNOTES_PORT',
  'DRYNOTES_LOGIN',
  'GA_TRACKING_ID',
  'HOT_RELOADING',
  'LOG_LEVEL',
  'NODE_ENV',
  'FIREBASE_API_KEY',
  'FIREBASE_AUTH_DOMAIN',
  'FIREBASE_PROJECT_ID',
  'FIREBASE_STORAGE_BUCKET',
  'FIREBASE_MESSAGING_SENDER_ID',
  'FIREBASE_APP_ID',
  'FIREBASE_MEASUREMENT_ID',
];

const isBrowser = typeof window !== 'undefined';
// console.log('isBrowser', isBrowser);

/* eslint-disable-next-line no-underscore-dangle */
// const base = (isBrowser ? window.__ENV__ : constants) || {};
const base = constants || {};
const env = {};

publicEnv.forEach((key) => {
  env[key] = base[key];
});

// console.info(`Shared Application environment: ${JSON.stringify(env)}`);
module.exports = env;
